module.exports = __webpack_public_path__ + "static/img/light-02.1339008.png";